<template>
  <v-app>
    <v-app-bar app dark class="bg-black" style="height: 80px">
      <v-container>
        <img class="logo-custom" alt="Kawasaki" src="@/assets/logo-white.png" />
        &nbsp; | &nbsp;
        <span class="primary--text title">Rewards Program</span>
        <v-spacer></v-spacer>
      </v-container>
      <v-btn small :to="{ name: 'login' }">Back to Login</v-btn>
    </v-app-bar>
    <v-main class="login-bg">
      <v-container class="fill-height">
        <v-row justify="center">
          <v-col cols="12" xs="12" sm="10" md="10" lg="8" xl="8" class="mt-5 mb-5">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-footer absolute>
      <Footer></Footer>
    </v-footer>
  </v-app>
</template>

<script>
import Footer from "@/components/Footer";
import { mapGetters } from "vuex";

export default {
  name: "LayoutPublicRegistration",
  components: {
    Footer
  },
  async mounted() {
    // Do NOT logout since we are reusing this layout for "join" programs
    // this.$auth.logout();

    this.loading = true;
    let programKey = process.env.VUE_APP_PROGRAM_KEY;
    await this.$api
      .get("/api/programs/byKey/" + programKey + "/public")
      .then(({ data }) => {
        let program = data;
        return Promise.all([
          this.$auth.storeSelectProgram(program),
          this.$auth.storeSelectProgramGroup(program.programGroup),
          this.$auth.storeSelectClient(program.programGroup.client)
        ]).then(() => {
          return this.$i18n
            .determine()
            .then(locale => {
              console.log("Determined locale: " + (locale ? locale.code : "None"));
            })
            .catch(e => {
              console.log(e);
            });
        });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    ...mapGetters(["selectedProgram"])
  }
};
</script>
